// extracted by mini-css-extract-plugin
export default {"field":"legal-name_field__rpZkm"};